

















import { getDefaultSystemSettings } from '@/components/helper'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import SettingsModuleComponent from '@/shared/views/SettingsModuleComponent.vue'
import AccountOption from '@/api/models/AccountOption'
import AccountService from '@/api/services/AccountService'
import SystemSettings from '@/models/SystemSettings'
import AccountOptionsComponent from '@/shared/views/AccountOptionsComponent.vue'
import AccountOptionsMixin from '@/components/mixins/AccountOptionsMixin.vue'

const accountService = new AccountService()

@Component({
    components: {
        AccountOptionsComponent,
        SettingsModuleComponent
    }
})
export default class SettingsModuleBase extends mixins(AccountOptionsMixin) {
    private currentSettingsModule: SystemSettings = getDefaultSystemSettings()

    async loadData(): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                this.currentSettingsModule = await accountService.getAccountSystemOptions(this.currentAccount.id)
                this.accountOptions = await accountService.getAccountOptions(this.currentAccount.id)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.system.getSystemOptionsError').toString()
        } finally {
            this.setLoading(false)
        }
    }

    async updateSettingModule(settingModule: AccountOption): Promise<void> {
        this.clearError()
        this.setLoading(true)

        try {
            if (this.currentAccount?.id) {
                await accountService.updateAccountOptions(this.currentAccount.id, settingModule)
            }
        } catch (err) {
            this.error = err.response?.data?.message ?? this.$t('settings.system.error').toString()
        } finally {
            this.setLoading(false)
        }
    }
}

